

/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', form);
    },
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
      $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form.shopify-product-form',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
    
    // update cart count in header
    $('.main-sidebar-cart-count-amount').text(cart.item_count);
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
    
    // Specific override for Cross Sell Form
    $(document).on('submit', '#cross-sell-form', function(evt){
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');
    
	 $addToCart.removeClass('is-added').addClass('is-adding');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append("<p>You don't have any items in your cart yet.</p>");
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);
    
    //Check for gift-wrap
	let containsGiftWrap = false;
    
    const revampedSKUs = [
      	'BRA-CRM-XXS', 'BRA-CRM-XSM', 'BRA-CRM-SML', 'BRA-CRM-MED', 'BRA-CRM-LRG', 'BRA-CRM-XLG', 'BRA-CRM-XXL', 'BRA-CRM-3XL', 
      	'BRA-ONX-XXS', 'BRA-ONX-XSM', 'BRA-ONX-SML', 'BRA-ONX-XLG', 'BRA-ONX-XXL', 'BRA-ONX-3XL',
		'BRA-BSH-XXS', 'BRA-BSH-XSM', 'BRA-BSH-SML', 'BRA-BSH-XLG', 'BRA-BSH-XXL', 'BRA-BSH-3XL',
      	'BRA-RCH-XXS', 'BRA-RCH-XSM', 'BRA-RCH-3XL',
      	'BRA-AGV-XXS', 'BRA-AGV-XSM', 'BRA-AGV-SML', 'BRA-AGV-MED', 'BRA-AGV-LRG', 'BRA-AGV-XLG', 'BRA-AGV-XXL', 'BRA-AGV-3XL'
    ];
    
    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }
      
      let isGiftWrap = false
      
      if (cartItem.product_title === "Gift Wrap") {
      	containsGiftWrap = true;
        isGiftWrap = true;
        console.log("gift wrap? " + containsGiftWrap);
      }
      
      let revamped = false;
      
      if (revampedSKUs.includes(cartItem.sku)) {
      	revamped = true;
      }
      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
        giftWrap: isGiftWrap,
        isRevamped: revamped
      };

      items.push(item);
    });
    
    // Cart shipping upsell goal, these variables are added to the cart data as: cartGoalReached and untilGoal
    
    let cartGoal = 0;
    let leftUntilGoal = cartGoal - cart.total_price;
    
    let crossSellProduct;
    let crossSellOptions = [];
    
    if (cart.item_count > 0) {

      let lastItem = cart.items[0];
      let lastItemSKU = lastItem.sku;
      let productType = lastItemSKU.split("-")[0];
      let productColor = lastItemSKU.split("-")[1];
      let productSize = lastItemSKU.split("-")[2];
      let crossSell;
	  let targetSize;
      let variantColor;
      let variantImageID;
      let variantImageSrc;
      let variantImageHeight;
      let variantImageWidth;
      
      if (productType !== "BTS" || productType !== "BSV") {
          console.log('new products');
      
        if (productSize === "XSM") {
          targetSize = "XS";
        }
        else if (productSize === "SML") {
          targetSize = "S";
        }
        else if (productSize === "MED") {
          targetSize = "M";
        }
        else if (productSize === "LRG") {
          targetSize = "L";
        } 
        else if (productSize === "XLG") {
          targetSize = "XL";
        } 
        else if (productSize === "XXL") {
          targetSize = "XXL";
        } 
        else {
          targetSize = null;
        }

        if (productColor === "FORNOW") {
          productColor = "PER";
          productSize = "SML";
        }
      
     }
        
      const initCrossSell = function(crossSell){

        //console.log(crossSell);
        let crossSellProduct = crossSell.product.product;
        
        for (let variant of crossSellProduct.variants) {
          if (variant.sku.includes(productColor)) {
            variantImageID = variant.image_id;
            variantColor = (productColor === "DPK") ? "Rose" : variant.option1;
            for (let variantImage of crossSellProduct.images){
              if (variantImage.id === variantImageID) {
              	variantImageSrc = variantImage.src.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
                variantImageWidth = variantImage.width;
                variantImageHeight = variantImage.height;
              }
            }
              
            // let variantImageID = variant.image_id;
            break;
          };
        };
        
        for (let variant of crossSellProduct.variants) {
          if (variant.sku.includes(productColor)) {
            let variantOption;
            
            if (productColor === "DPK") {
            	variantOption = variant.option1;
            } else {
            	variantOption = variant.option2
            }
            
            crossSellOptions.push({
              id: variant.id,
              size: variantOption,
              selected: variantOption === targetSize ? true : false
             })
          };
        };
        
        let variantPrice = Math.trunc(crossSellProduct.variants[0].price);
 
        data = {
          items: items,
          note: cart.note,
          totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
          totalCartDiscount: cart.total_discount === 0 ? 0 : "Saved [savings]".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
          totalCartDiscountApplied: cart.total_discount === 0 ? false : true,
          giftWrap: containsGiftWrap,
          target: crossSellProduct,
          targetOptions: crossSellOptions,
          targetImage: variantImageSrc,
          targetImageWidth: variantImageWidth,
          targetImageHeight: variantImageHeight,
          targetColor: variantColor,
          targetPrice: variantPrice,
          showCartMessage: null,
          cartMessage: null,
          cartGoal: null,
          cartGoalReached: cart.total_price >= cartGoal ? true : false,
          cartGoalReachedCopy: '',
          cartGoalNotReachedCopy: ''.replace('((cart_goal_price))', Shopify.formatMoney(leftUntilGoal, settings.moneyFormat).replace(".00", ""))
        }
        
        $cartContainer.append(template(data));
        cartCallback(cart);
        $('#cross-sell-form').removeClass('hide');       
      };

//       if (productType === "BTS") {
        
// //         let targetSKU = ["BSV", productColor, productSize].join("-");
// //         let targetHandle = 'sleeveless-bodysuit';
        
// //         jQuery.getJSON('/products/'+targetHandle, function(product) {
// //           let crossSell = {
// //             product: product,
// //             sku: targetSKU,
// //             options: []
// //           };

// //           initCrossSell(crossSell);

// //         });
        
//       } else if (productType === "BSV") {
        
// //        	let targetSKU = ["BTS", productColor, productSize].join("-");
// //         let targetHandle = 'scoop-neck-bodysuit';
        
// //         jQuery.getJSON('/products/'+targetHandle, function(product) {
// //           let crossSell = {
// //             product: product,
// //             sku: targetSKU,
// //             options: []
// //           };

// //           initCrossSell(crossSell);

// //         });
        
//       } else 
      
      if (productType === "BRA") {
        
        let targetProductID = (productColor === "DPK") ? "4305958371410" : "1462251159664"; // Signature Briefs
        let targetSKU = ["BRF", productColor, productSize].join("-");
        let targetHandle = (productColor === "DPK") ? "signature-brief-rose-exclusive" :  "bottom-brief";

        if (productColor === "AGV") {
          productColor = "BSH";
          targetSKU = ["BRA", productColor, productSize].join("-");
        }
        
        jQuery.getJSON('/products/'+targetHandle, function(product) {
          let crossSell = {
            product: product,
            sku: targetSKU,
            options: []
          };

          initCrossSell(crossSell);

        });
      } else if (productType === "SOC") {
        
        if (lastItemSKU === "SOC-FORNOW") {
          let targetProductID = "4945676632146"; //Socks
          let targetSKU = "SOC-PER-SML";
          let targetHandle = "the-socks";
          
          console.log(targetHandle);
          
          jQuery.getJSON('/products/' + targetHandle, function(product) {
            let crossSell = {
              product: product,
              sku: targetSKU,
              options: []
            };

            initCrossSell(crossSell);

          });

        } else {
          let targetProductID = (productColor === "DPK") ? "4305958371410" : "1462251159664"; // Signature Briefs
          let targetSKU;
          let targetHandle = (productColor === "DPK") ? "signature-brief-rose-exclusive" :  "bottom-brief";

          if (productColor === "PER"){
              productColor = "BSH";
              targetSKU = ["BRF", productColor, productSize].join("-");
            
          }
          
          else {
              targetSKU = ["BRF", productColor, productSize].join("-");
          }
          
          jQuery.getJSON('/products/' + targetHandle, function(product) {
              let crossSell = {
                product: product,
                sku: targetSKU,
                options: []
              };

            initCrossSell(crossSell);

          });
        }       
      } else if (productType === "THG") {
        let targetProductID = "4945676632146"; //Socks
        let targetSKU;
        
        if (productColor === "BSH" || productColor === "HON" || productColor === "AGV"){
        	productColor = "PER";
        	targetSKU = ["BRF", productColor, productSize].join("-");
        } else if (productColor === "CRM" || productColor === "RCH"){
        	productColor = "ONX";
        	targetSKU = ["BRF", productColor, productSize].join("-");
        } else {
        	targetSKU = ["BRF", productColor, productSize].join("-");
        }
        
        let targetHandle = "the-socks";
        

        jQuery.getJSON('/products/'+targetHandle, function(product) {
          let crossSell = {
            product: product,
            sku: targetSKU,
            options: []
          };

          initCrossSell(crossSell);

        });
      } else if (productType === "BRF" || productType === "NPC"){
        let targetProductID = (productColor === "DPK") ? "4305985437778" : "1462251061360"; // Signature Thong
        let targetSKU = ["THG", productColor, productSize].join("-");
        let targetHandle = (productColor === "DPK") ? "signature-thong-rose-exclusive" : "bottom-thong";


        if (productColor === "AGV") {
          productColor = "ONX";
          targetSKU = ["BRF", productColor, productSize].join("-");
        }
        
        jQuery.getJSON('/products/'+targetHandle, function(product) {
          let crossSell = {
            product: product,
            sku: targetSKU,
            options: []
          };

          initCrossSell(crossSell);
        });
      } else {
        crossSell = null;
       data = {
          items: items,
          note: cart.note,
          totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
          totalCartDiscount: cart.total_discount === 0 ? 0 : "Saved [savings]".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
          totalCartDiscountApplied: cart.total_discount === 0 ? false : true,
          giftWrap: containsGiftWrap,
          showCartMessage: null,
          cartMessage: null,
          cartGoal: null,
          cartGoalReached: cart.total_price >= cartGoal ? true : false,
          cartGoalReachedCopy: '',
          cartGoalNotReachedCopy: ''.replace('((cart_goal_price))', Shopify.formatMoney(leftUntilGoal, settings.moneyFormat).replace(".00", ""))
        }
        $cartContainer.append(template(data));
        cartCallback(cart);
      }
      
    } else {
     // Gather all cart data and add to DOM
      data = {
        items: items,
        note: cart.note,
        totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
        totalCartDiscount: cart.total_discount === 0 ? 0 : "Saved [savings]".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
        totalCartDiscountApplied: cart.total_discount === 0 ? false : true,
        giftWrap: containsGiftWrap,
        showCartMessage: null,
        cartMessage: null,
        cartGoal: null,
        cartGoalReached: cart.total_price >= cartGoal ? true : false,
        cartGoalReachedCopy: '',
        cartGoalNotReachedCopy: ''.replace('((cart_goal_price))', Shopify.formatMoney(leftUntilGoal, settings.moneyFormat).replace(".00", ""))
      }
      $cartContainer.append(template(data));
      cartCallback(cart);
    }
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    
    // Remove from cart
    $body.on('click', '.remove-button', function(e) {
      e.preventDefault();

      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__meta-wrapper').find('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Sety qty to 0
      qty = 0;

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number

      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });
    
    
    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    $body.on('click', '#cross-sell-form [data-product-variants]', function() {
      $('#cross-sell-form [data-product-variants]').removeClass('active');
      $(this).addClass('active');
    });

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));

$(document.body).on('click', '.csf-remove-button', function() {
	$('#cross-sell-form').addClass('hide');
});